module.exports = __webpack_public_path__ + "img/Stage_5_Atmo.4511fa1e.jpg";